import * as MetaReducers from './packages.metareducer';
import * as Reducers from './packages.reducer';

export const PackagesReducers = {
  MetaReducers,
  Reducers,
};
